<template>
    <v-container fluid>
        <v-row>
            <v-col
                cols="4"
            >
                <v-card>
                    <v-card-title style="fontSize: 14px;">
                        <v-icon class="mr-3">mdi-chat</v-icon>Service / Supplier Request
                    </v-card-title>
                    <v-card-text>
                        <v-list dense>
                            <v-list-item-group
                                color="primary"
                            >
                                <v-list-item
                                    v-for="(item, i) in get_service_supplier"
                                    :key="i"
                                    @click="content_clicked(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon>mdi-comment-account</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <label
                                                v-if="item.get_client_information !== null"
                                            >
                                                {{item.get_client_information.name}} | {{item.get_information_of_request.build_stage}}
                                            </label>
                                            <label v-else>
                                                N/A Deleted User
                                            </label>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col
                cols="8"
                v-if="get_service_supplier_convo.length > 0"
            >
                <v-row
                    no-gutters
                >
                    <v-container
                        v-for="(item_chat, item_chat_index) in get_service_supplier_convo"
                        :key="item_chat_index"
                    >
                    <v-card
                        v-if="item_chat.from_client === 1"
                        color="blue darken-4"
                        style="float: left;"
                        class="rounded-tl-0"
                    >
                        <v-card-text>
                            <small class="white--text">client</small>
                            <h4 class="white--text" style="display:block;">{{item_chat.message}}</h4>
                            <small class="white--text" style="display:block;">{{item_chat.created_at}}</small>
                        </v-card-text>
                    </v-card>
                    <v-card
                        v-if="item_chat.from_supplier === 1"
                        color="blue darken-2"
                        style="float: right;"
                        class="rounded-tr-0"
                    >
                        <v-card-text>
                            <small class="white--text">you</small>
                            <h4 class="white--text">{{item_chat.message}}</h4>
                            <small class="white--text">{{item_chat.created_at}}</small>
                        </v-card-text>
                    </v-card>
                    </v-container>
                    <v-container>
                    <v-row
                        class="pa-2"
                    >
                        <v-text-field
                            rounded
                            v-model="message"
                            placeholder="Reply Here..."
                            outlined
                            append-icon="send"
                            @click:append="send_message"
                        ></v-text-field>
                    </v-row>
                    </v-container>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>
  
<script>
import { mapGetters } from 'vuex'
  export default {
    components: {
    },
    props: [
    ],
    data: () => ({
        message: null,
        dd: {}
    }),
    async mounted () {
        await this.$store.dispatch('supplier_inbox/set_service_supplier')
    },
    created () {
    },
    computed: {
        ...mapGetters({
            get_service_supplier:           'supplier_inbox/get_service_supplier',
            get_service_supplier_convo:     'supplier_inbox/get_service_supplier_convo'
        })
    },
    methods: {
        showSnackBar(message){
            this.$store.commit("auth/setMessage", 
            {show: true, message: message}, 
            {root: 1})
        },
        async content_clicked(data){
            this.dd = data
            await this.$axios.get(`/supplier/from_form/get_convo/${data.form_request_id}`)
            .then(({data}) => {
                this.$store.dispatch('supplier_inbox/set_service_supplier_convo', data.data)
            })
        },
        async send_message(){
            if(this.dd.get_client_information === null){
                this.showSnackBar('Deleted User')
                this.message = null
                return
            }
            this.showSnackBar('Please wait...')
            let tp = {
                client_id:          this.get_service_supplier_convo[0].client_id,
                form_request_id:    this.get_service_supplier_convo[0].form_request_id,
                message:            this.message,
                from_supplier:      1
            }
            await this.$axios.post('/supplier/from_form/send_message', tp)
            .then(({data}) => {
                if(data.response){
                    this.content_clicked(tp)
                    this.showSnackBar(data.message)
                    this.message = null
                    return
                }
                this.showSnackBar(data.message)
            })
        }
    },
    watch: {
    }
  }
</script>
  
<style scoped lang="scss">
</style>